module.exports = __webpack_public_path__ + "static/kinetic-40de6aeb4cebab32d46080d41a3ed12e.jpg";